import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-e-way-cfl-popup',
  templateUrl: './e-way-cfl-popup.component.html',
  styleUrls: ['./e-way-cfl-popup.component.css']
})
export class EWayCflPopupComponent {
  dataSource!: MatTableDataSource<any>;
  displayColumnList: string[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
  public dialogRef: MatDialogRef<EWayCflPopupComponent>) {
    this.displayColumnList = Object.keys(this.data.info[0])
    this.dataSource = new MatTableDataSource(data.info);
  }

  getActualString(str: string) {
    let finalResult = str.charAt(0).toUpperCase() + str.slice(1);
    return finalResult.replace(/([A-Z])/g, " $1").trim();
  }

  selectItem(item: any) {
    this.dialogRef.close({event: item});
  }
}
